
import Vue from "vue";
import buttonCom from "@/components/ButtonCom.vue";
import searchInput from "@/components/SearchInputCom.vue";
export default Vue.extend({
  components: { buttonCom, searchInput },
  props: {
    select: Boolean,
    insert: Boolean,
    del: Boolean,
    modify: Boolean,
    ex: Boolean,
    inport: Boolean,
    power: Boolean,
    role: Boolean,
    edit: Boolean,
    down: Boolean,
    temp: Boolean,
    exp: Boolean,
    imp: Boolean,
    batch: Boolean,
    password: Boolean,
    ota: Boolean,
    showOnline: Boolean,
    showOrderState: Boolean,
    hidenSearch: Boolean,
    manuCharge: Boolean,
    chargeEnable: Boolean,
    showAssetState: Boolean,
    asynDev: Boolean,
    showAssetType: Boolean,
    showWorkTypes: Boolean,
    downAi: Boolean,
    check: Boolean,
    approve: Boolean,
    assetTypes: [] as any[],
    orderTypes: [] as any[],
  },
  data() {
    return {
      search: "",
      online: 2,
      orderState: -1,
      assetState: -1,
      assetType: -1,
      workType: -1,
    };
  },
  methods: {
    searchChanged(search: string) {
      this.search = search;
      this.$emit("searchChanged", search);
    },
    searchClick(search: string) {
      this.search = search;
      this.$emit("search", this.search);
    },
    searchChange() {
      this.$emit("search", this.search);
    },
    getSearch() {
      let ret: any = {};
      let show = false;
      ret.searchStr = this.search;
      console.log("actionbar");
      if (this.showOnline && this.online != 2) {
        ret.online = this.online + "";
        show = true;
      }
      if (this.showOrderState && this.orderState != -1) {
        ret.orderState = this.orderState + "";
        show = true;
      }
      if (this.showAssetState && this.assetState != -1) {
        ret.assetState = this.assetState + "";
        show = true;
      }
      if (this.showAssetType && this.assetType != -1) {
        ret.assetType = this.assetType + "";
        show = true;
      }
      if (this.showWorkTypes && this.workType != -1) {
        ret.workType = this.workType + "";
        show = true;
      }
      if (show) {
        return ret;
      } else {
        return this.search;
      }
    },
  },
});
